import { SearchResult } from 'types/search';
import baseFetch from '../baseFetch';

export const fetchSearchResults = async (
  term: string,
  cookies: { [key: string]: string },
  {
    size = 10,
    newsSearch = true,
    includeWavePools = false,
  }: {
    size?: number;
    newsSearch?: boolean;
    includeWavePools?: boolean;
  } = {},
) => {
  let url = `/search/site?q=${term}&querySize=${size}&suggestionSize=${size}&newsSearch=${newsSearch}`;
  if (includeWavePools) {
    url += '&includeWavePools=true';
  }
  return baseFetch<Array<SearchResult>>(url, {
    cookies,
  });
};

export default fetchSearchResults;
